<template>
  <div class="card p-3 mb-3 shadow">
    <div
      class="py-3 px-4 text-center text-uppercase font-weight-bold text-primary bg-light border">
      {{ title }}
    </div>

    <div v-if="prescriptions.length > 0">
      <ClientDrugShoplistItem
        v-for="prescription in prescriptions"
        :key="prescription.id"
        :prescription="prescription"/>
    </div>

    <div
      v-else
      class="">
      Список пуст
    </div>
  </div>
</template>

<script>
import ClientDrugShoplistItem from './Item';

export default {
  name: 'ClientDrugShoplistList',

  props: ['prescriptions', 'title'],

  components: {ClientDrugShoplistItem},
};
</script>
